import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as FttsIcon } from '../../Assets/AlertIcon/ftts.svg';
import { ReactComponent as MpbnIcon } from '../../Assets/AlertIcon/MPBN.svg';
import { ReactComponent as OtnIcon } from '../../Assets/AlertIcon/OTN.svg';
import { ReactComponent as IPRANIcon } from '../../Assets/AlertIcon/IPRAN.svg';
import { getAvailableNetworkMonitoringPermissions } from '../../common/functions/permission_utils.function';

const StyledButton = styled(Box)(({ theme, isActive }) => ({
  width: '32px',
  height: '42px',
  borderRadius: '4px',
  backgroundColor: isActive ? '#BD1D23' : '#F8E8E9',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  border: '1px solid #E5E9EB',
  padding: '2px',
  '&:hover': {
    backgroundColor: isActive ? '#8B1519' : '#F0F0F0',
    transform: 'scale(1.05)',
  },
}));

const StyledIcon = styled('div')(({ theme, isActive }) => ({
  width: '18px',
  height: '18px',
  marginBottom: '4px',
  '& svg': {
    width: '100%',
    height: '100%',
    '& path': {
      fill: isActive ? '#ffffff' : '#192126',
    },
  },
}));

const NetworkMonitoringButtons = ({
  selectedTab,
  onTabChange,
  onReset,
  onSetFiltersValue,
  onDrawerClose,
}) => {
  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
    // Reset filters when switching tabs (same as original left sidebar behavior)
    if (onSetFiltersValue) {
      onSetFiltersValue({ region: '', city: '', ring: '', link: '', site: '' });
    }
    // Reset component state
    if (onReset) {
      onReset();
    }
    // Close drawer if open
    if (onDrawerClose) {
      onDrawerClose();
    }
  };

  const buttons = [
    { name: 'FTTS', icon: FttsIcon, permission: 'FTTS' },
    { name: 'MPBN', icon: MpbnIcon, permission: 'MPBN' },
    { name: 'OTN', icon: OtnIcon, permission: 'OTN' },
    { name: 'IPRAN', icon: IPRANIcon, permission: 'IPRAN' },
  ];

  // Get available network monitoring permissions
  const availablePermissions = getAvailableNetworkMonitoringPermissions(permissionNames);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '70px',
        left: '32px',
        zIndex: 1000,
        // backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '8px',
        padding: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
      }}
    >
      <Grid container spacing={1} justifyContent="center">
        {buttons
          .filter((button) => availablePermissions.includes(button.permission))
          .map((button) => {
            const IconComponent = button.icon;
            const isActive = selectedTab === button.name.toLowerCase();

            return (
              <Grid item key={button.name}>
                <StyledButton
                  isActive={isActive}
                  onClick={() => handleTabClick(button.name.toLowerCase())}
                >
                  <StyledIcon isActive={isActive}>
                    <IconComponent />
                  </StyledIcon>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '8px',
                      fontWeight: 600,
                      color: isActive ? '#ffffff' : '#192126',
                      textAlign: 'center',
                      lineHeight: 1,
                      marginBottom: '2px',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    {button.name}
                  </Typography>
                </StyledButton>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default NetworkMonitoringButtons;
